import { c as _c } from "react/compiler-runtime";
import { Home } from '@systemeio/digital-store-shared';
import { FileSourceEnum } from '@systemeio/file-manager';
import { Checkbox, FormInput, FormSelect, Hint, useWindowSize } from '@systemeio/ui';
import { SettingsSection } from 'modules/profile/components/settings-section';
import { AvailablePlansEnum } from 'modules/profile/user-plan/enums/user-plan-type-enum';
import { useEffect, useState } from 'react';
import CodeEditor from 'shared/components/code-editor';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { EditableItemType } from 'shared/components/edit-modal';
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image';
import FormUrlPathInput from 'shared/components/form-url-path-input';
import { FieldLabel } from 'shared/components/form/field-label';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePaymentMethodsByCurrency } from 'shared/hooks/use-payment-methods-by-currency';
import useUser from 'shared/hooks/use-user';
import useUserDomains from 'shared/hooks/use-user-domains';
import { getLocaleSelectOptions } from 'shared/utils/locale/get-locale-select-options';
import { generatePathFromName } from 'shared/utils/path-utils';
import { storeDefaultErrors } from '../../constants/store-default-values';
import { StoreErrorsInterface, StoreInterface } from '../../types/stores-interface';
import { allowedDSPaymentMethods } from '../content/product/components/payment-methods-edit-modal';
import { useStorePreviewContext } from '../context/store-preview-context';
import { useStoreEdit } from '../hooks/use-store-edit';
import StoreEditForm from './store-edit-form';
import { isSioHost } from '@systemeio/util';
interface StoreEditProps {
  store: StoreInterface;
}
const StoreEdit = t0 => {
  const $ = _c(61);
  const {
    store: instance
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    width
  } = useWindowSize();
  const isSm = width < 640;
  const {
    user
  } = useUser();
  const {
    userDomainsSelect,
    userDomains
  } = useUserDomains();
  const {
    setPreview
  } = useStorePreviewContext();
  let t1;
  if ($[0] !== instance.id || $[1] !== instance.items || $[2] !== instance.profile || $[3] !== instance.socialLinks || $[4] !== setPreview) {
    t1 = () => {
      setPreview([<Home key={instance.id} profile={instance.profile} socialLinks={instance.socialLinks} items={instance.items.filter(_temp)} displayAffiliateLink={false} />]);
    };
    $[0] = instance.id;
    $[1] = instance.items;
    $[2] = instance.profile;
    $[3] = instance.socialLinks;
    $[4] = setPreview;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== instance || $[7] !== setPreview) {
    t2 = [setPreview, instance];
    $[6] = instance;
    $[7] = setPreview;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  const [errors, setErrors] = useState(storeDefaultErrors);
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      setErrors
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const {
    onSave
  } = useStoreEdit(t3);
  let t4;
  if ($[10] !== t) {
    t4 = t("dashboard.payment_methods.currency.change_info");
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== errors || $[13] !== instance.currency || $[14] !== t4) {
    t5 = {
      currencyChangeMessage: t4,
      currency: instance.currency,
      errors,
      allowedPaymentMethods: allowedDSPaymentMethods
    };
    $[12] = errors;
    $[13] = instance.currency;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const {
    currencyAndPaymentMethodsEditFields
  } = usePaymentMethodsByCurrency(t5);
  let t6;
  if ($[16] !== errors || $[17] !== t) {
    t6 = {
      field: "name",
      onRender: (value, onChange) => <FormInput required={true} key="store-name-edit" label={t("global.name")} value={value} onChange={e => onChange(e.target.value)} error={errors.name} />
    };
    $[16] = errors;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const nameField = t6;
  let t7;
  if ($[19] !== errors || $[20] !== t || $[21] !== userDomainsSelect) {
    t7 = {
      field: "domainId",
      onRender: (value_0, onChange_0) => <FormSelect required={true} withoutCloseIcon={true} key="store-domain-edit" onChange={value_1 => value_1 && onChange_0(value_1)} value={value_0} label={t("dashboard.communities.domain_name")} data={userDomainsSelect} error={errors.domainId} />
    };
    $[19] = errors;
    $[20] = t;
    $[21] = userDomainsSelect;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const domainField = t7;
  let t8;
  if ($[23] !== domainField || $[24] !== nameField) {
    t8 = [nameField, domainField];
    $[23] = domainField;
    $[24] = nameField;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const nameAndDomainFieldsSm = t8;
  let t9;
  if ($[26] !== domainField || $[27] !== nameField) {
    t9 = [[nameField, domainField]];
    $[26] = domainField;
    $[27] = nameField;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  const nameAndDomainFields = t9;
  const t10 = isSm ? nameAndDomainFieldsSm : nameAndDomainFields;
  let t11;
  if ($[29] !== errors || $[30] !== t || $[31] !== userDomainsSelect) {
    t11 = {
      field: "path",
      onRender: (value_2, onChange_1, data) => <FormUrlPathInput key="store-path-edit" error={errors.path} value={value_2} onChange={e_0 => onChange_1(e_0.target.value)} onFocus={e_1 => {
        if (!e_1.target.value) {
          onChange_1(generatePathFromName(data.name));
        }
      }} label={t("global.url_path")} domainName={userDomainsSelect?.find(el_0 => el_0.id === data.domainId)?.caption} />
    };
    $[29] = errors;
    $[30] = t;
    $[31] = userDomainsSelect;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== errors || $[34] !== t) {
    t12 = {
      field: "locale",
      onRender: (value_3, onChange_2) => <FormSelect required={true} withoutCloseIcon={true} key="store-locale-edit" onChange={value_4 => value_4 && onChange_2(value_4)} value={value_3} label={t("global.language")} data={getLocaleSelectOptions(t)} placeholder={t("global.language")} error={errors.locale} />
    };
    $[33] = errors;
    $[34] = t;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== userDomains) {
    t13 = state => isSioHost(window.location.host) && userDomains?.find(domain => state.domainId === domain.id)?.isWhiteLabel === false;
    $[36] = userDomains;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t || $[39] !== user?.userPlanId) {
    t14 = (value_5, onChange_3) => <div className="flex flex-col gap-1" key="store-affiliate-link-edit"><FieldLabel label={<Hint label={t("dashboard.store.affiliate.hint")}>{t("dashboard.store.affiliate.title")}</Hint>} /><Checkbox value={value_5} onChange={value_6 => onChange_3(value_6)} label={<div className="flex gap-1"><span>{t("dashboard.store.affiliate.checkbox.label")}</span>{user?.userPlanId === AvailablePlansEnum.freemium && <Hint label={t("dashboard.store.affiliate.tooltip.label")} />}</div>} disabled={user?.userPlanId === AvailablePlansEnum.freemium} /></div>;
    $[38] = t;
    $[39] = user?.userPlanId;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] !== t13 || $[42] !== t14) {
    t15 = [{
      field: "displayAffiliateLink",
      shouldRender: t13,
      onRender: t14
    }];
    $[41] = t13;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== errors?.author || $[45] !== errors?.description || $[46] !== errors?.keywords || $[47] !== errors?.title || $[48] !== t) {
    t16 = [{
      field: "seo",
      onRender: (value_7, onChange_4) => <SettingsSection headingTitle={t("dashboard.store.seo_settings.title")}><FormInput key="store-seo-title-edit" label={t("dashboard.store.seo.meta_title")} value={value_7?.title ?? ""} onChange={e_2 => onChange_4({
          ...value_7,
          title: e_2.target.value
        })} error={errors?.title} /><FormInput key="store-seo-description-edit" label={t("dashboard.store.seo.meta_description")} value={value_7?.description ?? ""} onChange={e_3 => onChange_4({
          ...value_7,
          description: e_3.target.value
        })} error={errors?.description} /><FormInput key="store-seo-keywords-edit" label={t("dashboard.store.seo.keywords")} value={value_7?.keywords ?? ""} onChange={e_4 => onChange_4({
          ...value_7,
          keywords: e_4.target.value
        })} error={errors?.keywords} /><FormInput key="store-seo-author-edit" label={t("dashboard.store.seo.author")} value={value_7?.author ?? ""} onChange={e_5 => onChange_4({
          ...value_7,
          author: e_5.target.value
        })} error={errors?.author} /><ImageUploaderWithPreviewImage key="store-seo-image-edit" dropZoneClassName="mb-4" value={value_7.image ? {
          path: value_7.image.path
        } : undefined} source={FileSourceEnum.DigitalStore} onSelect={file => {
          onChange_4({
            ...value_7,
            image: file
          });
        }} onRemove={() => {
          onChange_4({
            ...value_7,
            image: null
          });
        }} /><DisclosureBox panelClassName="p-0" wrapperClassName="border border-text-secondary/30 rounded-lg" title={<Hint label={t("dashboard.store.seo.tracking_code_popover_title")}>{t("dashboard.store.seo.tracking_code")}</Hint>}><CodeEditor onChange={text => onChange_4({
            ...value_7,
            trackingCode: text
          })} value={value_7.trackingCode} /></DisclosureBox><Checkbox key="store-seo-hide-from-search-engine-edit" value={value_7?.hideFromSearchEngines} onChange={checked => onChange_4({
          ...value_7,
          hideFromSearchEngines: checked
        })} label={t("dashboard.store.seo.hide_from_search_engines")} /></SettingsSection>
    }];
    $[44] = errors?.author;
    $[45] = errors?.description;
    $[46] = errors?.keywords;
    $[47] = errors?.title;
    $[48] = t;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  let t17;
  if ($[50] !== currencyAndPaymentMethodsEditFields || $[51] !== t10 || $[52] !== t11 || $[53] !== t12 || $[54] !== t15 || $[55] !== t16) {
    t17 = [...t10, t11, t12, ...currencyAndPaymentMethodsEditFields, t15, t16];
    $[50] = currencyAndPaymentMethodsEditFields;
    $[51] = t10;
    $[52] = t11;
    $[53] = t12;
    $[54] = t15;
    $[55] = t16;
    $[56] = t17;
  } else {
    t17 = $[56];
  }
  let t18;
  if ($[57] !== instance || $[58] !== onSave || $[59] !== t17) {
    t18 = <><StoreEditForm onEdit={onSave} instance={instance} editable={t17} /></>;
    $[57] = instance;
    $[58] = onSave;
    $[59] = t17;
    $[60] = t18;
  } else {
    t18 = $[60];
  }
  return t18;
};
export default StoreEdit;
function _temp(el) {
  return !el.draft;
}